import React from "react"
import { Box, Container, Heading, Text } from "@chakra-ui/react"
import { useMedia } from "@hooks/useMedia"

import { SectionProps, withSection } from "@app/hoc/Section"

export type WorkshopTestimonialsProps = GatsbyTypes.SanitySectionWorkshopTestimonials & SectionProps

const WorkshopTestimonials: React.FC<WorkshopTestimonialsProps> = ({ title, items }: WorkshopTestimonialsProps) => {
  const { isBase } = useMedia()
  const starArray = [1, 2, 3, 4, 5]

  return (
    <Container pb="80px">
      <Heading as="h2" size="h2" fontSize="24px" fontWeight="400" pb="24px" textAlign="center">
        {title}
      </Heading>
      <Box borderTop="0.5px solid #e9e9e9" maxWidth="1200px" width="100%" margin="0 auto">
        {items?.map((item, index) => (
          <Box key={index} display="flex" flexDirection={isBase ? "column" : "row"} pt="24px" pb="24px" borderBottom="0.5px solid#e9e9e9">
            <Box display="flex" flexDirection="column" width={isBase ? "100%" : "25%"} pb={isBase ? "16px" : "0"}>
              <Box fontWeight="400" fontSize="14px" pb="16px">
                {item?.location}
              </Box>
              <Box display="flex" sx={{ span: { paddingRight: "2.5px" } }}>
                {starArray.map((star, index) => (
                  <span key={index} className="mr-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="black">
                      <path
                        d="M7.58255 1.4026C7.9307 0.599719 9.0693 0.599718 9.41745 1.4026L10.9807 5.00756C11.1256 5.34171 11.4407 5.57066 11.8033 5.60521L15.7149 5.97794C16.586 6.06095 16.9379 7.14382 16.2819 7.72304L13.3364 10.3238C13.0634 10.5648 12.9431 10.9353 13.0222 11.2908L13.8765 15.1261C14.0667 15.9803 13.1456 16.6495 12.392 16.2046L9.00839 14.207C8.69475 14.0218 8.30525 14.0218 7.99161 14.207L4.60798 16.2046C3.85439 16.6495 2.93325 15.9803 3.12351 15.1261L3.97777 11.2908C4.05695 10.9353 3.93658 10.5648 3.66356 10.3238L0.718107 7.72304C0.0621094 7.14382 0.413955 6.06095 1.28513 5.97794L5.19671 5.60521C5.55929 5.57066 5.87441 5.34171 6.01931 5.00756L7.58255 1.4026Z"
                        fill="#000"
                      />
                    </svg>
                  </span>
                ))}
              </Box>
            </Box>
            <Box fontSize="14px" display="flex" flexDirection="column">
              <Box mb="8px">{item?.title}</Box>
              <Box mb="12px" fontWeight="300">
                <Text fontWeight="300" fontSize="14px">
                  {item?.review}
                </Text>
              </Box>
              <Box display="flex" color="#938e88">
                <Box pr="3px"> {`${item?.name},`} </Box>
                <Box> {item?.date} </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Container>
  )
}

export default React.memo(withSection(WorkshopTestimonials))
